<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      :left-arrow="true"
      :z-index="10"
      :title="getNavTitle"
      @click-left="goableBack()"></van-nav-bar>
    <div class="contain">
      <div class="title-bg">设置密码</div>
      <van-cell-group class="group">
        <van-field
          class="username"
          v-model="settingPwd.pwd"
          type="password"
          :formatter="formatter"
          maxlength="18"
          placeholder="请输入密码"
          border
          clearable />
        <van-field
          v-model="settingPwd.confirmPwd"
          type="password"
          :formatter="formatter"
          maxlength="18"
          placeholder="请再次输入密码确认"
          border
          clearable />
      </van-cell-group>
      <van-button
        class="btn"
        color="rgb(206, 29, 35)"
        round
        type="warning"
        @click="onNextAction"
        v-preventReClick="500"
        >确认</van-button
      >
    </div>
  </div>
</template>
      
      <script>
import * as CustApi from "@/api/cust"

import { CellGroup, Field, Toast } from "vant"
import session from "../../utils/session"
import { mapActions } from "vuex"

export default {
  name: "settingPwd",
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  data() {
    return {
      cacheParams: {
        type: 1, // 1 忘记密码 2 注册 3 登录后未设置密码 4 个人中心进入设置密码
        mobile: "",
        name: "",
        idNumber: "",
        referrerCode: ""
      },
      settingPwd: {
        pwd: "",
        confirmPwd: ""
      }
    }
  },
  computed: {
    getNavTitle() {
      if (this.cacheParams.type == 1) {
        return "忘记密码"
      } else if (this.cacheParams.type == 2) {
        return "注册"
      } else if (this.cacheParams.type == 3) {
        return "设置密码"
      } else if (this.cacheParams.type == 4) {
        return "设置密码"
      } else {
        return ""
      }
    }
  },
  beforeMount() {
    this.cacheParams = session.getJson("RegisterAndForgetPwdKey")
  },
  beforeDestroy() {},
  methods: {
    ...mapActions(["getUserInfo"]),
    formatter(value) {
      // 只能输入英文字母和数字
      return value.replace(/[^\w]/g, "")
    },
    onNextAction() {
      if (this.settingPwd.pwd.length < 6) {
        this.$toast("请输入6到18位新密码")
        return
      }
      if (this.settingPwd.confirmPwd.length < 6) {
        this.$toast("请输入6到18位确认密码")
        return
      }
      if (this.settingPwd.pwd != this.settingPwd.confirmPwd) {
        this.$toast("两次输入的密码不一致")
        return
      }
      if (this.cacheParams.type != 4) {
        this.settingPwd.phone = this.cacheParams.mobile
      }
      CustApi.setLoginPwd(this.settingPwd)
        .then((data) => {
          if (data) {
            session.del("RegisterAndForgetPwdKey")
            if (this.cacheParams.type == 4) {
              this.getUserInfo()
              this.goableBack()
            } else {
              this.$router.replace("/login")
            }
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    }
  }
}
</script>
      
      <style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 45px);
  background-color: white;
  overflow: hidden;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px 0;
}
.title-bg {
  margin: 50px 20px;
  font-size: 20px;
  font-weight: 500;
}
.group {
  margin: 50px 40px;
  .username {
    margin-bottom: 30px;
  }
  .van-field {
    border: 1px solid rgb(208, 211, 213);
    border-radius: 5px;
    font-size: 15px;
  }
}
.btn {
  margin: 0 40px;
  height: 44px;
  width: calc(100vw - 80px);
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
}
</style>
      